import { Card } from "~/features/configurator/Linear/components/Card";
import { Button, Skeleton, type SkeletonProps, Stack, styled } from "~/common/mui";
import { CORNER_EXTRA_LARGE } from "~/common/components/icon/Corners";

// Button skeleton component similar to the one in SearchResultSkeleton
const ButtonSkeleton = ({ fullWidth, ...props }: SkeletonProps & { fullWidth?: boolean }) => (
  <Skeleton
    variant="rectangular"
    width={fullWidth ? "100%" : undefined}
    sx={{ borderRadius: CORNER_EXTRA_LARGE }}
    {...props}
  >
    <Button>.</Button>
  </Skeleton>
);

export interface FrequentlyBoughtTogetherItemSkeletonProps {
  /**
   * Optional className to apply to the component
   */
  className?: string;
}

const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  width: "100%",
  background: "white",

  [theme.breakpoints.up("tablet")]: {
    flexDirection: "row",
  },

  [theme.breakpoints.up("desktop-s")]: {
    flexDirection: "column",
  },
}));

const ImageSkeleton = styled(Skeleton)({
  width: "64px",
  height: "64px",
});

/**
 * Skeleton component for FrequentlyBoughtTogetherItem
 * Displays placeholder UI while product data is loading
 */
export const FrequentlyBoughtTogetherItemSkeleton = ({ className }: FrequentlyBoughtTogetherItemSkeletonProps) => {
  return (
    <StyledCard className={className}>
      <Stack gap={2} direction={"row"} flex={1}>
        <ImageSkeleton />

        <Stack gap={1} flex={1}>
          <Skeleton width={"80%"} height={28} />
          <Skeleton width={"95%"} height={20} />
        </Stack>
      </Stack>

      <Stack gap={2} direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} flex={1}>
        <Skeleton width={102} height={24} />
        <ButtonSkeleton width={143} />
      </Stack>
    </StyledCard>
  );
};
